const AMPLITUDE_DATA = {
  "main": {
    "메인컨셉비디오 클릭": {
      name: "메인컨셉비디오 클릭",
      event: "",
    },
    "메인 워크시트 클릭": {
      name: "메인 워크시트 클릭",
      event: "",
    },
    "매쓰팜": {
      name: "매쓰팜",
      event: "",
    }
  },
  "on-boarding": {
    "on-boarding화면 조회": {
      name: "on-boarding화면 조회",
      event: "",
    },
    "학습시작하기 클릭": {
      name: "학습시작하기 클릭",
      event: "",
    },
  },
  "sign-up": {
    "회원가입 시작": {
      name: "회원가입 시작",
      event: "",
    },
    "서비스이용 동의 설정": {
      name: "서비스이용 동의 설정",
      event: "",
    },
    "가입자정보입력화면 조회": {
      name: "가입자정보입력화면 조회",
      event: "",
    },
    "이메일인증 클릭": {
      name: "이메일인증 클릭",
      event: "",
    },
    "학습자정보입력화면 조회": {
      name: "학습자정보입력화면 조회",
      event: "",
    }
  },
  test: {
    "진단test 시작": {
      name: "진단test 시작",
      event: "",
    },
    "진단test안내 조회": {
      name: "진단test안내 조회",
      event: {
        "소스화면": ""
      }
    },
    "진단다시하기 클릭": {
      name: "진단다시하기 클릭",
      event: {
        "소스화면": ""
      },
    },
    "진단연습장 초기화": {
      name: "진단연습장 초기화",
      event: "",
    },
    "진단연습장 종료": {
      name: "진단연습장 종료",
      event: "",
    }
  },
  lms: {
    "실시간학습현황 조회": {
      name: "실시간학습현황 조회",
      event: "",
    },
    "진단결과 조회": {
      name: "진단결과 조회",
      event: {
        "소스화면": "",
      }
    },

  },
  "app_usage": {
    "log-in화면 조회": {
      name: "log-in화면 조회",
      event: "",
    },
    "메인메뉴 조회": {
      name: "메인메뉴 조회",
      event: "",
    },
    "메인메뉴 닫기": {
      name: "메인메뉴 닫기",
      event: "",
    },
    "코스학습메인 조회": {
      name: "코스학습메인 조회",
      event: {
        "소스화면": "",
      }
    },
    "주제학습메인 조회": {
      name: "주제학습메인 조회",
      event: {
        "소스화면": "",
      }
    },
    "ocr학습메인 조회": {
      name: "ocr학습메인 조회",
      event: {
        "소스화면": "",
      }
    },
    "학습노트_코스학습 조회": {
      name: "학습노트_코스학습 조회",
      event: {
        "소스화면": "",
      }
    },
    "학습노트_주제학습 조회": {
      name: "학습노트_주제학습 조회",
      event: {
        "소스화면": "",
      }
    },
    "학습노트_ocr학습 조회": {
      name: "학습노트_ocr학습 조회",
      event: {
        "소스화면": "",
      }
    },

  },
  "account": {
    "로그인 실행": {
      name: "로그인 실행",
      event: "",
    },
    "로그아웃 실행": {
      name: "로그아웃 실행",
      event: "",
    },
    "회원 탈퇴": {
      name: "회원 탈퇴",
      event: "",
    },
    "회원 정보변경": {
      name: "회원 정보변경",
      event: "",
    }
  },
  "ocr": {
    "ocr안내 조회": {
      name: "ocr안내 조회",
      event: {
        "소스화면": "",
      }
    },
    "ocr히스토리 조회": {
      name: "ocr히스토리 조회",
      event: {
        "소스화면": "",
      }
    },
    "ocr소주제추천 조회": {
      name: "ocr소주제추천 조회",
      event: {
        "소스화면": "",
      }
    },
  },
  "learning": {
    "학습연습장 초기화": {
      name: "학습연습장 초기화",
      event: "",
    },
    "학습연습장 종료": {
      name: "학습연습장 종료",
      event: "",
    },
    "보기조회 종료": {
      name: "보기조회 종료",
      event: "",
    }
  }, 
  "payment" : {
    "결제팝업버튼 클릭" : {
      name: "결제팝업버튼 클릭",
      event: "",
    }
  }
}

export default AMPLITUDE_DATA;

